<div class="tile-card-view" (click)="onTileCardClick()">
  <div class="content">
    <div class="header">
      <div class="title">
        <span class="tile-name">{{ description }}</span>
        @if (showTypeInTitle && types) {
          <span>{{ getTileType(types[0]) }}</span>
        }
      </div>
      <span #topRightOverride><ng-content select="[topRightOverride]"></ng-content></span>
      @if (!topRightOverride || topRightOverride.children.length == 0) {
        <span class="tile-types">
          @for (type of types; track type) {
            <ndt-tile-type-icon [type]="type"></ndt-tile-type-icon>
          }
        </span>
      }
    </div>

    @if (designerDescription) {
      <p class="description">
        {{ designerDescription || 'Designer description not available.' }}
      </p>
    }
  </div>
</div>
